export enum ReviewInterval {
  NONE = 'P0D',
  WEEKDAY = 'P1D',
  WEEKLY = 'P1W',
  MONTHLY = 'P1M',
  QUARTERLY = 'P3M',
  ANNUALLY = 'P1Y',
}

export enum ReviewFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum Weekday {
  MONDAY = 'MO',
  TUESDAY = 'TU',
  WEDNESDAY = 'WE',
  THURSDAY = 'TH',
  FRIDAY = 'FR',
  SATURDAY = 'SA',
  SUNDAY = 'SU',
}
